import React from "react";
import { Chip } from "@mui/material";
import { alpha, darken } from "@mui/material/styles";
import { number, string } from "prop-types";

const newChipStyles = {
  base: {
    textTransform: "uppercase",
    fontWeight: 700,
    letterSpacing: ".03em",
  },
  green: (theme) => ({
    textTransform: "uppercase",
    fontWeight: 700,
    letterSpacing: ".03em",
    background: darken(theme.palette.primary.main, 0.3),
    border: `1px solid ${theme.palette.common.white}`,
    color: theme.palette.common.white,
  }),
  white: (theme) => ({
    textTransform: "uppercase",
    fontWeight: 700,
    letterSpacing: ".03em",
    background: alpha(theme.palette.common.white, 0.5),
    border: `1px solid ${theme.palette.common.white}`,
    color: theme.palette.common.black,
  }),
};

const NewChip = ({ count, size, variant = "green" }) => {
  const label = count ? `New (${count})` : "New";
  return <Chip sx={newChipStyles[variant]} label={label} size={size || "medium"} />;
};

NewChip.propTypes = {
  count: number,
  size: string,
  variant: string,
};

export default NewChip;
